import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UsuarioProvider } from '../providers/usuario.provider';

@Injectable({
    providedIn: 'root'
})
export class AutenticadoGuard implements CanActivate {

    constructor(
        private router: Router,
        private usuarioProvider: UsuarioProvider
    ) {

    }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.validate();
    }

    private async validate() {
        try {
            const tokenExpired = await this.usuarioProvider.verificarToken();
            const autenticado = await this.usuarioProvider.isAutenticado();
            if (autenticado && !tokenExpired) {
                return true;
            } else {
                await this.router.navigate(['login']);
                return false;
            }
        } catch (error) {
            throw error;
        }
    }

}
